import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {/* Logo & Description */}
          <div>
            <a href="/" className="flex items-center gap-2 mb-4" data-testid="footer-logo">
              <div className="w-10 h-10 bg-[#D32F2F] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl" style={{ fontFamily: 'Manrope, sans-serif' }}>JJ</span>
              </div>
              <span 
                className="text-xl font-bold text-white"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                buyshouses
              </span>
            </a>
            <p className="text-slate-400 leading-relaxed">
              We buy houses fast for cash, nationwide. Get a fair offer today and close on your timeline.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Contact Us
            </h3>
            <div className="space-y-3">
              <a 
                href="tel:626-526-1420" 
                className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 text-[#D32F2F]" />
                <span>626-526-1420</span>
              </a>
              <a 
                href="mailto:Sell@JJbuyshousesforcash.com" 
                className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-[#D32F2F]" />
                <span>Sell@JJbuyshousesforcash.com</span>
              </a>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-[#D32F2F]" />
                <span>Serving Nationwide</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              Quick Links
            </h3>
            <div className="space-y-2">
              <a 
                href="#how-it-works" 
                className="block text-slate-400 hover:text-white transition-colors"
                data-testid="footer-link-how"
              >
                How It Works
              </a>
              <a 
                href="#why-us" 
                className="block text-slate-400 hover:text-white transition-colors"
                data-testid="footer-link-why"
              >
                Why Choose Us
              </a>
              <a 
                href="#testimonials" 
                className="block text-slate-400 hover:text-white transition-colors"
                data-testid="footer-link-testimonials"
              >
                Testimonials
              </a>
              <a 
                href="#faq" 
                className="block text-slate-400 hover:text-white transition-colors"
                data-testid="footer-link-faq"
              >
                FAQ
              </a>
              <a 
                href="#get-offer" 
                className="block text-slate-400 hover:text-white transition-colors"
                data-testid="footer-link-offer"
              >
                Get Your Offer
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} JJbuyshouses. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a 
              href="#" 
              className="text-slate-500 hover:text-white text-sm transition-colors"
              data-testid="footer-privacy"
            >
              Privacy Policy
            </a>
            <a 
              href="#" 
              className="text-slate-500 hover:text-white text-sm transition-colors"
              data-testid="footer-terms"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
